import { Record, Map } from "immutable";

const RealtimeDataItemRecord = Record({
  timestamp: null, // timestamp
  voltage: null,
  current: null,
  activePower: null,
  reactionPower: null,
  apparentPower: null
});

const createRealtimeDataItemRecord = dataItem => {
  return RealtimeDataItemRecord(dataItem);
};

const createGenericRealtimeDataItem = dataItem => {
  return Map(dataItem);
};

export { createRealtimeDataItemRecord, createGenericRealtimeDataItem };

export default RealtimeDataItemRecord;
